import { Box } from '@mui/material';
import { LinearProgressChart, QuickViewReferenceValue, QuickViewWidget } from '@procureai/ui-mui';

export const ContractValidityWidget = () => {
  return (
    <QuickViewWidget
      title="Validity"
      subTitle="Value explanation long lorem ipsum dolor sit"
      value="1.07M"
      referenceValue={<QuickViewReferenceValue value="4 vs. 8" dotColor="error" />}
      data-intercom-target="ContractValidityWidget"
    >
      <Box
        sx={{
          alignSelf: 'flex-end',
          width: '100%',
        }}
      >
        <LinearProgressChart color="error" value={75} min={0} max={100} dotColor="error" />
      </Box>
    </QuickViewWidget>
  );
};
